import request from './common/request'
import qs from 'qs'

import { MERCHANT_FINANCE_ACCOUNT_STATEMENT_URL } from './urls'

async function list (params) {
  return request({
    url: MERCHANT_FINANCE_ACCOUNT_STATEMENT_URL,
    method: 'GET',
    params: params
  })
}

async function getServiceChargeSetting () {
  return request({
    url: `${MERCHANT_FINANCE_ACCOUNT_STATEMENT_URL}/merchantServiceChargeSetting`,
    method: 'GET'
  })
}
async function getMaxWithdrawCashAmount () {
  return request({
    url: `${MERCHANT_FINANCE_ACCOUNT_STATEMENT_URL}/maxWithdrawcashAmount`,
    method: 'GET'
  })
}

async function withdrawCashApply (data) {
  return request({
    url: `${MERCHANT_FINANCE_ACCOUNT_STATEMENT_URL}/withdrawcash`,
    method: 'POST',
    data: qs.stringify(data)
  })
}

export default {
  list,
  getServiceChargeSetting,
  getMaxWithdrawCashAmount,
  withdrawCashApply
}



// WEBPACK FOOTER //
// ./src/api/merchant-finance-account-statement.js